import CustomMenuBadge from './CustomMenuBadge';

export default CustomMenuBadge;
